import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PlexEnvironment } from '@app/env';
import { AuthConstants } from 'app/common/constants/AuthConstants';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AppRoleGuardService implements CanActivate {
  public auth = inject(AuthService);
  public router = inject(Router);
  private environment = inject(PlexEnvironment);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRoles = (route.data as any).expectedRoles as Array<string>;

    if (this.environment.security && expectedRoles && expectedRoles.length > 0) {

      let location = state.url;
      let redirect = (location === '/access-denied' || location === '/authorize') ? '/' : location;

      if (!this.auth.isAuthenticated()) {
        this.auth.redirectUrl = redirect;

        this.router.navigate(['authorize'], { state: { redirect: redirect } });
        return false;
      }

      let requestedRoles = new Array<string>();
      for (let role in AuthConstants.ROLES) {
        let appRole = AuthConstants.ROLES[role];
        if (expectedRoles.includes(appRole.name))
          requestedRoles.push(appRole.name);
      }

      if (!this.auth.userHasAnyRole(requestedRoles)) {
        this.auth.redirectUrl = redirect;

        this.router.navigate(['access-denied'], { state: { redirect: redirect } });
        return false;
      }

    }

    return true;
  }

}